import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.css'],
    standalone: false
})
export class OtpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
